import { createContext, useCallback, useContext, useMemo, useState } from "react";

const ConciergeContext = createContext(null);

/** Lets any page open the corner AI concierge, optionally with a question to ask right away. */
export function ConciergeProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(null);
  const openWith = useCallback((q) => {
    setPending(q ? { q, at: Date.now() } : null);
    setOpen(true);
  }, []);
  const value = useMemo(() => ({ open, setOpen, openWith, pending, clearPending: () => setPending(null) }), [open, openWith, pending]);
  return <ConciergeContext.Provider value={value}>{children}</ConciergeContext.Provider>;
}

export const useConcierge = () => useContext(ConciergeContext);
